var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_270)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6955 0.99981L32.9998 10.8515V29.1477L17.6955 38.9997L0.999904 29.1126V10.8571L17.6955 0.99981Z",
    fill: "#FEFEFE",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9661 0.579385L17.7068 0.412472L17.4413 0.569253L0.745698 10.4265L0.499904 10.5716V10.8571V29.1126V29.3976L0.74513 29.5429L17.4407 39.4299L17.7064 39.5872L17.9661 39.4201L33.2704 29.5682L33.4998 29.4205V29.1477V10.8515V10.5787L33.2704 10.431L17.9661 0.579385Z",
    stroke: "#FEFEFE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99983 21.9541C8.99983 21.9541 12.1118 24.3833 15.4215 21.7682C14.6806 21.5807 13.5938 21.4412 14.6311 20.4137C14.6311 20.4137 13.0736 20.1279 12.6807 19.3688C12.732 19.2556 13.2611 18.9331 13.7733 18.9811C13.3977 18.7554 11.9463 18.3194 12.0149 17.3506C12.9025 17.3346 12.988 17.3346 12.988 17.3346C12.988 17.3346 11.4514 16.3174 11.622 15.2195C12.9541 15.6395 15.669 16.5272 17.2571 18.0928C17.4278 17.48 18.1963 15.1709 19.8186 14.1701C19.8355 14.5415 19.8355 14.5415 19.8355 14.5415C19.8355 14.5415 20.5697 13.831 21.0138 14.0572C20.843 14.3798 20.843 14.3798 20.843 14.3798C20.843 14.3798 21.3724 14.1861 21.7478 14.2829C21.4065 14.5255 20.5869 14.6549 20.365 15.1389C20.7236 15.1389 23.3705 14.9772 23.9338 18.158C24.8728 18.2548 25.3853 18.3354 25.9316 18.0611C25.6749 18.4002 25.4877 18.7065 24.1215 18.8839C24.5825 19.0457 25.5729 19.2236 25.9999 19.1108C25.6584 19.4331 25.2658 19.8853 24.1042 19.7239C23.5237 21.2576 22.0212 24.6646 15.8908 25.0029C14.9005 24.9549 11.1953 24.9066 8.99983 21.9541Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_270",
    x: 0,
    y: -0.174805,
    width: 35.9998,
    height: 43.8496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_270",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7b194710b4aa6ddf9bce223533b711e4.svg";
export { ForwardRef as ReactComponent };